module.exports = __webpack_public_path__ + "static/img/xs1-5.b14d98f.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xs1-5.png
// module id = 799
// module chunks = 0